import { render, staticRenderFns } from "./TherapistDashModalAddExpenditure.vue?vue&type=template&id=afd889ee&scoped=true"
import script from "./TherapistDashModalAddExpenditure.vue?vue&type=script&lang=js"
export * from "./TherapistDashModalAddExpenditure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afd889ee",
  null
  
)

export default component.exports